/** Readable rows from the supplied diameter reference, plus requested 5.5/6.5 mm.
 * Saved rows outside this list are retained; blanks are presentation-only customer inheritance.
 */
export const PRICING_DIAMETERS = [5.5, 6.5, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 14, 16, 18, 20, 22, 25, 28, 32, 36];

export function completeDiameterRows<T extends { diameter: number }>(rows: T[], blank: (diameter: number) => T, additional: number[] = []): T[] {
  const byDiameter = new Map(rows.map(row => [Number(row.diameter), row]));
  [...PRICING_DIAMETERS, ...additional].forEach(diameter => {
    if (!byDiameter.has(diameter)) byDiameter.set(diameter, blank(diameter));
  });
  return [...byDiameter.values()].sort((a, b) => a.diameter - b.diameter);
}
